import Tab from 'react-bootstrap/Tab';
import "./index.scss"

const CustomTab = ({activetab, eventKey, title, styles, children}) => {

    
    return (
        <>
            <Tab
                id={activetab ? "activeTab" : "inactiveTab"}
                title={title}
                style={styles}
                eventKey={eventKey}
            > 
                {children}
            </Tab>
        </>
    );


};
  
export default CustomTab;
  